/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LeadAppraisalInheritanceNextStep = "buy" | "sell" | "share";
export type LeadAppraisalReason = "already_for_sale" | "buy_soon" | "buy_this" | "inheritance" | "move_rental" | "not_selling" | "not_set" | "other" | "other_not_owner" | "other_owner" | "other_renting" | "refinance" | "sell" | "separation";
export type LeadAppraisalSeparationNextStep = "buy" | "sell" | "share";
export type LeadAppraisalStep = "address" | "asset_details" | "asset_type" | "result" | "user_details" | "verification";
export type LeadBuyHorizon = "not_set" | "over_12_months" | "under_12_months" | "under_3_months";
export type LeadGender = "female" | "male";
export type LeadMortgageBuyingStatus = "identified" | "offer" | "searching" | "visited";
export type LeadMortgageStatus = "not_started" | "working_with_bank" | "working_with_independent";
export type LeadOwnership = "co_ownership" | "corporate_ownership" | "sole_ownership";
export type LeadProfessionalSituation = "business_owner" | "employed" | "retired" | "self_employed" | "unemployed";
export type LeadPropertyUsage = "not_set" | "other" | "primary_residence" | "rental_property" | "secondary_residence";
export type LeadRelationship = "agent" | "buyer" | "heir" | "not_set" | "other" | "owner" | "past_owner" | "tenant";
export type LeadSaleHorizon = "already_for_sale" | "from_1_to_2_years" | "from_2_years" | "from_6_to_12_months" | "not_selling" | "not_set" | "under_6_months";
export type PropertyCooling = "air_conditioning" | "ceiling_fans" | "none";
export type PropertyHeatingDistribution = "floor" | "forced_air" | "other" | "radiators" | "stove";
export type PropertyOrientation = "E" | "N" | "NE" | "NW" | "S" | "SE" | "SW" | "W";
export type PropertySearchNotification = "daily" | "never" | "weekly";
export type UserMaritalStatus = "cohabitation" | "divorced" | "married" | "separated" | "single" | "widowed";
export type LeadInput = {|
  id?: ?string,
  source?: ?string,
  sourceId?: ?string,
  sourceOrganisationId?: ?string,
  parentLeadId?: ?string,
  completed?: ?boolean,
  stageId?: ?string,
  property?: ?PropertyInput,
  appraisalStep?: ?LeadAppraisalStep,
  appraisalPropertyRoute?: ?string,
  appraisalPropertyStreetNumber?: ?string,
  appraisalPropertyLocality?: ?string,
  appraisalPropertyPostcode?: ?string,
  appraisalPropertyState?: ?string,
  appraisalPropertyCtn?: ?string,
  appraisalPropertyCountry?: ?string,
  appraisalPropertyCountryCode?: ?string,
  appraisalPropertyLng?: ?number,
  appraisalPropertyLat?: ?number,
  appraisalPropertyGoogleAddress?: ?GoogleAddressInput,
  appraisalPropertyGoogleAddressId?: ?string,
  appraisalPropertyPropertyTypeId?: ?string,
  appraisalPropertyFloorOfFlat?: ?number,
  appraisalPropertyNumberOfFloors?: ?number,
  appraisalPropertySide?: ?string,
  appraisalPropertyNumberOfRooms?: ?number,
  appraisalPropertyNumberOfBedrooms?: ?number,
  appraisalPropertyNumberOfBathrooms?: ?number,
  appraisalPropertyLandSurface?: ?number,
  appraisalPropertyLivingSurface?: ?number,
  appraisalPropertyBuiltSurface?: ?number,
  appraisalPropertyBalconySurface?: ?number,
  appraisalPropertyGardenSurface?: ?number,
  appraisalPropertyCommercialSurface?: ?number,
  appraisalPropertyResidentialSurface?: ?number,
  appraisalPropertyHasElevator?: ?boolean,
  appraisalPropertyHasStorageRoom?: ?boolean,
  appraisalPropertyHasSwimmingPool?: ?boolean,
  appraisalPropertyHasView?: ?boolean,
  appraisalPropertyHasGarden?: ?boolean,
  appraisalPropertyIsRenovated?: ?boolean,
  appraisalPropertyNumberOfIndoorParkings?: ?number,
  appraisalPropertyNumberOfOutdoorParkings?: ?number,
  appraisalPropertyConstructionYear?: ?number,
  appraisalPropertyRenovationYear?: ?number,
  appraisalPropertyNumberOfResidentialUnits?: ?number,
  appraisalPropertyNumberOfCommercialUnits?: ?number,
  appraisalPropertyIsResidentialFullyRented?: ?boolean,
  appraisalPropertyIsCommercialFullyRented?: ?boolean,
  appraisalPerceivedValue?: ?number,
  appraisalPropertyResidentialYearlyRentalIncome?: ?number,
  appraisalPropertyCommercialYearlyRentalIncome?: ?number,
  appraisalPropertyResidentialPotentialRentalIncome?: ?number,
  appraisalPropertyCommercialPotentialRentalIncome?: ?number,
  appraisalPropertyIncomeIncludesParking?: ?boolean,
  appraisalPropertyIsParkingFullyRented?: ?boolean,
  appraisalPropertyKnowPlotNumber?: ?boolean,
  appraisalPropertyParkingYearlyRentalIncome?: ?number,
  appraisalPropertyParkingPotentialRentalIncome?: ?number,
  appraisalPropertyPlotNumber?: ?string,
  appraisalPropertyBuildingCondition?: ?number,
  appraisalMonthlyGrossRent?: ?number,
  appraisalInheritanceNextStep?: ?LeadAppraisalInheritanceNextStep,
  appraisalSeparationNextStep?: ?LeadAppraisalSeparationNextStep,
  saleHorizon?: ?LeadSaleHorizon,
  saleIsSeller?: ?boolean,
  salePrice?: ?number,
  saleStarted?: ?boolean,
  saleComments?: ?string,
  saleHasFound?: ?boolean,
  propertyUsage?: ?LeadPropertyUsage,
  professionalSituation?: ?LeadProfessionalSituation,
  yearlyRevenuesAtRetirement?: ?number,
  mandateProbability?: ?number,
  predictedListingDate?: ?string,
  tags?: ?$ReadOnlyArray<?string>,
  buyHorizon?: ?LeadBuyHorizon,
  contactId?: ?string,
  secondContactId?: ?string,
  brokerId?: ?string,
  relationship?: ?LeadRelationship,
  ownership?: ?LeadOwnership,
  hasAcceptedTerms?: ?boolean,
  emailAddress?: ?string,
  phoneNumber?: ?string,
  appraisalReason?: ?LeadAppraisalReason,
  appraisalPerception?: ?string,
  partnerFirstName?: ?string,
  partnerLastName?: ?string,
  partnerGender?: ?LeadGender,
  partnerDateOfBirth?: ?string,
  partnerHasThirdPillar?: ?boolean,
  partnerUseBankThirdPillar?: ?boolean,
  partnerUseInsuranceThirdPillar?: ?boolean,
  partnerMaritalStatus?: ?UserMaritalStatus,
  partnerDonation?: ?number,
  partnerYearlyRevenuesAtRetirement?: ?number,
  partnerSavings?: ?number,
  partnerLastBonus?: ?number,
  partnerYearlyRevenues?: ?number,
  partnerSecondPillar?: ?number,
  partnerAnnualPremium?: ?number,
  partnerThirdPillar?: ?number,
  partnerHasOtherCredits?: ?boolean,
  partnerOtherCredits?: ?number,
  partnerOccupationText?: ?string,
  partnerNationalityId?: ?string,
  partnerResidenceStateId?: ?string,
  partnerResidenceCountryCode?: ?string,
  partnerWorkPermitId?: ?string,
  partnerProfessionalSituation?: ?LeadProfessionalSituation,
  potentialDevelopment?: ?boolean,
  numberOfBuyers?: ?number,
  hasDependantChildren?: ?boolean,
  numberOfDependantChildren?: ?number,
  gender?: ?LeadGender,
  dateOfBirth?: ?string,
  occupationId?: ?string,
  nationalityId?: ?string,
  residenceStateId?: ?string,
  residenceCountryCode?: ?string,
  workPermitId?: ?string,
  useSecondPillar?: ?boolean,
  useThirdPillar?: ?boolean,
  useBankThirdPillar?: ?boolean,
  useInsuranceThirdPillar?: ?boolean,
  hasOtherCredits?: ?boolean,
  secondPillar?: ?number,
  annualPremium?: ?number,
  thirdPillar?: ?number,
  otherCredits?: ?number,
  firstName?: ?string,
  lastName?: ?string,
  yearlyRevenues?: ?number,
  savings?: ?number,
  debt?: ?number,
  debts?: ?$ReadOnlyArray<?LeadDebtInput>,
  maxPropertyValue?: ?number,
  appraisalNextStep?: ?string,
  callTimes?: ?$ReadOnlyArray<?string>,
  mortgageBuyingStatus?: ?LeadMortgageBuyingStatus,
  mortgageStatus?: ?LeadMortgageStatus,
  receivedMortgageOffer?: ?boolean,
  treesStatus?: ?boolean,
  treesComment?: ?string,
  accessStatus?: ?boolean,
  accessComment?: ?string,
  noiseStatus?: ?boolean,
  noiseComment?: ?string,
  pollutionStatus?: ?boolean,
  pollutionComment?: ?string,
  groundStatus?: ?boolean,
  groundComment?: ?string,
  constructionPermitStatus?: ?boolean,
  constructionPermitComment?: ?string,
  inventoryProtectionStatus?: ?boolean,
  inventoryProtectionComment?: ?string,
  servitudesStatus?: ?boolean,
  servitudesComment?: ?string,
  neighbourhoodPlanStatus?: ?boolean,
  neighbourhoodPlanComment?: ?string,
  localityPlanStatus?: ?boolean,
  localityPlanComment?: ?string,
  cantonalPlanStatus?: ?boolean,
  cantonalPlanComment?: ?string,
  stepsTaken?: ?string,
  deadline?: ?string,
  neighbourhoodRelations?: ?string,
  askingPrice?: ?number,
  comment?: ?string,
  referrer?: ?string,
  landingPageUrl?: ?string,
  marketingSignals?: ?any,
  userInfoIp?: ?string,
  userInfoUserAgent?: ?string,
  propertySearchNotification?: ?PropertySearchNotification,
  appraisalPropertyOccupied?: ?string,
  appraisalOpenToOffer?: ?string,
  appraisalPropertyUsage?: ?string,
  appraisalSellingWith?: ?string,
  appraisalMarketTime?: ?string,
  maritalStatus?: ?string,
  occupationText?: ?string,
  lastBonus?: ?number,
  donation?: ?number,
  assetsSecondPillar?: ?number,
  assetsThirdPillarAOrganisation?: ?string,
  assetsThirdPillarAAnnualPremiumOrganization?: ?string,
  partnerThirdPillarAOrganisation?: ?string,
  hasNoStreetNumber?: ?boolean,
|};
export type PropertyInput = {|
  id?: ?string,
  createdBy?: ?string,
  googleAddressId?: ?string,
  streetNumber?: ?string,
  route?: ?string,
  state?: ?string,
  postcode?: ?string,
  localityId?: ?string,
  locality?: ?string,
  subLocality?: ?string,
  ctn?: ?string,
  country?: ?string,
  countryCode?: ?string,
  lng?: ?number,
  lat?: ?number,
  propertyTypeName?: ?string,
  propertyTypeId?: ?string,
  microLocation?: ?number,
  macroLocation?: ?number,
  livingSurface?: ?number,
  builtSurface?: ?number,
  usableSurface?: ?number,
  landSurface?: ?number,
  balconySurface?: ?number,
  gardenSurface?: ?number,
  terraceSurface?: ?number,
  basementSurface?: ?number,
  weightedFloorSurface?: ?number,
  grossFloorSurface?: ?number,
  residentialSurface?: ?number,
  commercialSurface?: ?number,
  numberOfResidentialUnits?: ?number,
  numberOfCommercialUnits?: ?number,
  isResidentialFullyRented?: ?boolean,
  isCommercialFullyRented?: ?boolean,
  residentialYearlyRentalIncome?: ?number,
  commercialYearlyRentalIncome?: ?number,
  residentialPotentialRentalIncome?: ?number,
  commercialPotentialRentalIncome?: ?number,
  incomeIncludesParking?: ?boolean,
  isParkingFullyRented?: ?boolean,
  parkingYearlyRentalIncome?: ?number,
  parkingPotentialRentalIncome?: ?number,
  numberOfRooms?: ?number,
  numberOfBedrooms?: ?number,
  numberOfBathrooms?: ?number,
  numberOfToilets?: ?number,
  numberOfIndoorParkings?: ?number,
  numberOfOutdoorParkings?: ?number,
  constructionYear?: ?number,
  renovationYear?: ?number,
  buildingStandard?: ?number,
  buildingCondition?: ?number,
  flatCondition?: ?number,
  minergieCode?: ?number,
  buildingVolume?: ?number,
  buildingVolumeNorm?: ?string,
  numberOfFlats?: ?number,
  numberOfFloors?: ?number,
  side?: ?string,
  floorOfFlat?: ?number,
  orientation?: ?PropertyOrientation,
  isOrientedNorth?: ?boolean,
  isOrientedSouth?: ?boolean,
  isOrientedEast?: ?boolean,
  isOrientedWest?: ?boolean,
  numberOfLifts?: ?number,
  isMaisonette?: ?boolean,
  shareOfOwnership?: ?number,
  isSecondaryResidence?: ?boolean,
  relevantServitudes?: ?boolean,
  plotIsConstructible?: ?boolean,
  plotHasConstructibleReserve?: ?boolean,
  plotNumber?: ?string,
  heating?: ?string,
  heatingDistribution?: ?PropertyHeatingDistribution,
  cooling?: ?PropertyCooling,
  isRental?: ?boolean,
  perceivedValue?: ?number,
  monthlyGrossRent?: ?number,
  hasElevator?: ?boolean,
  hasFireplace?: ?boolean,
  hasStorageRoom?: ?boolean,
  hasSwimmingPool?: ?boolean,
  hasCellar?: ?boolean,
  hasAttic?: ?boolean,
  hasPhotovoltaicPanels?: ?boolean,
  hasSauna?: ?boolean,
  hasGym?: ?boolean,
  hasWellnessArea?: ?boolean,
  isLuxury?: ?boolean,
  hasView?: ?boolean,
  isWheelchairAccessible?: ?boolean,
  isChildFriendly?: ?boolean,
  ceilingHeight?: ?number,
  deletedByUser?: ?boolean,
  distanceToPublicTransport?: ?number,
  distanceToGroceryShop?: ?number,
  distanceToKindergarten?: ?number,
  distanceToPrimarySchool?: ?number,
  distanceToHighSchool?: ?number,
  distanceToMotorway?: ?number,
  distanceToHospital?: ?number,
  distanceToCityCenter?: ?number,
  distanceToAirport?: ?number,
  distanceToTrainStation?: ?number,
  distanceToSportsCenter?: ?number,
  ownersIds?: ?$ReadOnlyArray<?string>,
  financingLeadId?: ?string,
  borrowerLeadId?: ?string,
  charges?: ?number,
  renovationFund?: ?number,
  emissions?: ?number,
  consumption?: ?number,
  energyReferenceYear?: ?number,
  estimatedLowerEnergyCost?: ?number,
  estimatedHigherEnergyCost?: ?number,
  energyCertificateVersion?: ?string,
  energyInspectionDate?: ?string,
  energyConsumptionClass?: ?string,
  gasEmissionsClass?: ?string,
|};
export type GoogleAddressInput = {|
  id?: ?string,
  googlePlace?: ?GooglePlaceInput,
  googlePlaceId?: ?string,
  formattedAddress?: ?string,
  country?: ?string,
  countryCode?: ?string,
  state?: ?string,
  ctn?: ?string,
  postcode?: ?string,
  locality?: ?string,
  route?: ?string,
  streetNumber?: ?string,
  lat?: ?number,
  lng?: ?number,
|};
export type GooglePlaceInput = {|
  address_components: $ReadOnlyArray<?GooglePlaceAddressComponents>,
  formatted_address?: ?string,
  geometry?: ?GooglePlaceGeometry,
  place_id?: ?string,
  partial_match?: ?boolean,
  plus_code?: ?PlusCode,
  types?: ?$ReadOnlyArray<?string>,
|};
export type GooglePlaceAddressComponents = {|
  long_name: string,
  short_name: string,
  types: $ReadOnlyArray<string>,
|};
export type GooglePlaceGeometry = {|
  bounds?: ?GooglePlaceGeometryGeometryBounds,
  location?: ?GooglePlaceGeometryLocation,
  location_type?: ?string,
  viewport?: ?GooglePlaceGeometryGeometryViewport,
|};
export type GooglePlaceGeometryGeometryBounds = {|
  south?: ?number,
  west?: ?number,
  north?: ?number,
  east?: ?number,
  northeast?: ?GooglePlaceGeometryBoundsNortheast,
  southwest?: ?GooglePlaceGeometryBoundsSouthwest,
|};
export type GooglePlaceGeometryBoundsNortheast = {|
  lat?: ?number,
  lng?: ?number,
|};
export type GooglePlaceGeometryBoundsSouthwest = {|
  lat?: ?number,
  lng?: ?number,
|};
export type GooglePlaceGeometryLocation = {|
  lat?: ?number,
  lng?: ?number,
|};
export type GooglePlaceGeometryGeometryViewport = {|
  south?: ?number,
  west?: ?number,
  north?: ?number,
  east?: ?number,
  northeast?: ?GooglePlaceGeometryViewportNortheast,
  southwest?: ?GooglePlaceGeometryViewportSouthwest,
|};
export type GooglePlaceGeometryViewportNortheast = {|
  lat?: ?number,
  lng?: ?number,
|};
export type GooglePlaceGeometryViewportSouthwest = {|
  lat?: ?number,
  lng?: ?number,
|};
export type PlusCode = {|
  compound_code?: ?string,
  global_code?: ?string,
|};
export type LeadDebtInput = {|
  id?: ?string,
  debt?: ?number,
  expiration?: ?string,
  leadId?: ?string,
  rate?: ?number,
|};
export type phoneVerificationUpdateLeadMutationVariables = {|
  lead: LeadInput
|};
export type phoneVerificationUpdateLeadMutationResponse = {|
  +upsertLead: ?{|
    +__typename: string
  |}
|};
export type phoneVerificationUpdateLeadMutation = {|
  variables: phoneVerificationUpdateLeadMutationVariables,
  response: phoneVerificationUpdateLeadMutationResponse,
|};
*/


/*
mutation phoneVerificationUpdateLeadMutation(
  $lead: LeadInput!
) {
  upsertLead(input: {lead: $lead}) {
    __typename
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lead"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "lead",
            "variableName": "lead"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UpsertLeadPayload",
    "kind": "LinkedField",
    "name": "upsertLead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "phoneVerificationUpdateLeadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "phoneVerificationUpdateLeadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a4aed60220bcb81010cbb215e05a8430",
    "id": null,
    "metadata": {},
    "name": "phoneVerificationUpdateLeadMutation",
    "operationKind": "mutation",
    "text": "mutation phoneVerificationUpdateLeadMutation(\n  $lead: LeadInput!\n) {\n  upsertLead(input: {lead: $lead}) {\n    __typename\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '10244e3f8a119cbd3cb91fe387112947';

export default node;
